.pageContent {
    padding: 20px 20px 0px;
    max-width: 1300px;
    margin: auto;
}

.removePadding {
    padding: 0px;
}